// vendors
import React from 'react';
import * as Yup from 'yup';
import moment from 'moment';

// components
import { Reinvite } from '../../Reinvite';

// constants
import { USER_TYPES } from 'constants/general';

// styles
import { FormTitle } from '../styles/TeacherProfileForm';

export const getValidations = () => ({
  name: Yup.string()
    .trim()
    .min(2, '')
    .max(50, ''),
  lastname: Yup.string()
    .trim()
    .min(2, '')
    .max(50, ''),
});
// export const getValidations = ({ translate }: any) => ({
//   name: Yup.string()
//     .min(2, translate('settings:CENTER_SECTION.CLASSROOM_CONFIG.MIN_CHARACTERS', { min: 2 }))
//     .max(50, translate('settings:CENTER_SECTION.CLASSROOM_CONFIG.MAX_CHARACTERS', { max: 50 })),
//   lastname: Yup.string()
//     .min(2, translate('settings:CENTER_SECTION.CLASSROOM_CONFIG.MIN_CHARACTERS', { min: 2 }))
//     .max(50, translate('settings:CENTER_SECTION.CLASSROOM_CONFIG.MAX_CHARACTERS', { max: 50 })),
//   email: Yup.string()
//     .email(translate('validations:INVALID_EMAIL'))
//     .required(translate('validations:FIELD_REQUIRED')),
// });

export const formFieldValidations = Yup.object().shape(getValidations());

export const buildDefaultValues = ({ teacherData = {} }: any) => {
  return {
    ...teacherData,
    reinvite: teacherData?.email,
    type: USER_TYPES[teacherData?.type],
    groups: teacherData.groups?.map((g: any) => ({ ...g, ...{ id: Number(g?.id), label: g?.name } })),
    centers: teacherData?.centers?.map((c: any) => ({ ...c, name: c?.name, label: c?.name, id: Number(c?.id), value: Number(c?.id) })),
  };
};

export const buildGeneralInfoFormFields = ({
  translate,
  beforeSendReinvite,
  teacherData: { confirmed },
}: any) => [
  {
    name: 'name',
    label: translate('common:NAME'),
  },
  {
    name: 'lastname',
    label: translate('common:LAST_NAME'),
  },
  {
    name: 'reinvite',
    label: `${translate('common:EMAIL_ADDRESS')}*`,
    disabled: false,
    customField: ({ onChangeField, renderProps }: any) => {
      return (
        <Reinvite
          disabledInput={confirmed}
          beforeSendReinvite={beforeSendReinvite}
          fieldName="reinvite"
          translate={translate}
          onChangeField={onChangeField}
          showReinviteButton={!confirmed}
          {...renderProps}
        />
      );
    },
  },
  {
    type: 'date',
    id: 'birthdate',
    name: 'birthdate',
    label: 'Birthday',
    dateProps: {
      icon: false,
      canSelectYear: true,
      showIndicator: false,
      placeholder: moment(new Date()).format('MMM/DD/YYYY'),
    },
  },
  {
    type: 'select',
    name: 'type',
    label: translate('settings:ROLE'),
    disabled: true,
    selectData: {
      data: [
        { name: translate('ROLE_TYPES.TEACHER'), id: 1, value: 1 },
        { name: translate('ROLE_TYPES.DIRECTOR'), id: 3, value: 3 },
        { name: translate('ROLE_TYPES.ADMINISTRATOR'), id: 4, value: 4 },
      ],
    },
  },
  {
    limit: '70',
    name: 'role_alias',
    label: translate(
      'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.LABEL_RENAME_POSITION',
    ),
  },
];

export const buildAssignedClassroomsFormFields = ({
  translate,
  groupList = [],
  centerList = [],
  centersSelected = [],
  teacherData: { centers = [], groups = [] },
}: any) => {

  return [
    {
      type: 'select',
      name: 'centers',
      label: translate('settings:CENTER_SECTION:CENTER'),
      selectData: {
        checkbox: true,
        multiple: true,
        data: centerList?.map(({ id, name, external_id }: any) => ({
          id,
          name,
          value: id,
          label: name,
          external_id: Number(external_id),
        })) || [],
      },
    },
    {
      type: 'select',
      name: 'groups',
      label: translate('settings:CENTER_SECTION:CLASSROOM'),
      selectData: {
        checkbox: true,
        multiple: true,
        returnValue: 'list',
        groupBy: 'parent',
        data: centerList?.flatMap((center: any) =>
          center?.groups?.map((group: any) => ({
            ...group,
            label: group?.name,
            value: group?.id,
            parent_id: center.id,
            parent_externalId: Number(center?.external_id),
            parent: { ...center, ...{ selected: false } },
          }))
        ).filter((g: any) =>
          g?.parent_externalId === centersSelected?.find((v: any) => v === g?.parent_externalId)) || [],
      },
    },
  ];
};

export const buildGeneralInfoFormFieldsSet = (params: any) => ({
  generalInfo: {
    fieldsSetTitle: (
      <FormTitle>
        {params.translate('settings:CENTER_SECTION.GENERAL_INFORMATION')}
      </FormTitle>
    ),
    fieldsSetData: buildGeneralInfoFormFields(params),
  },
  assignedClassrooms: {
    fieldsSetTitle: (
      <FormTitle id="assignedClassroomsFormFieldsTitle">
        {params.translate('settings:ASSIGNED_CLASSES')}
      </FormTitle>
    ),
    fieldsSetData: buildAssignedClassroomsFormFields(params),
  },
});

export const getValuesByKey = (data = [], key = 'id') =>
  data?.map((item: any) => item[key]);
